<template>
  <v-card>
    <v-toolbar color="indigo" dense>
      <v-toolbar-title class="white--text">Schedulatore</v-toolbar-title>
      <v-spacer></v-spacer><v-spacer></v-spacer><v-spacer></v-spacer>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            class="mr-5"
            @click="dialog_conferma_salva = true"
            small
            v-bind="attrs"
            v-on="on"
          >
            <v-icon color="success"> mdi-floppy </v-icon>
          </v-btn>
        </template>
        <span>Salva</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            @click="apriDialogWO"
            small
            v-bind="attrs"
            v-on="on"
            class="mr-5"
          >
            <v-icon color="primary">mdi-file-cog-outline</v-icon>
          </v-btn>
        </template>
        <span>Apri commesse</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            class="mr-5"
            @click="switchVista"
            small
            v-bind="attrs"
            v-on="on"
          >
            <v-icon color="primary"
              >mdi-{{
                visualizza_macchine ? "account" : "robot-industrial"
              }}</v-icon
            >
          </v-btn>
        </template>
        <span
          >Visualizza {{ visualizza_macchine ? "operatori" : "macchine" }}</span
        >
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            @click="
              apriDialogOptions();
              dataInizioTask();
            "
            small
            v-bind="attrs"
            v-on="on"
            class="mr-5"
          >
            <v-icon color="primary">mdi-cog</v-icon>
          </v-btn>
        </template>
        <span>Impostazioni</span>
      </v-tooltip>
      <v-tooltip bottom v-if="visualizza_macchine == false">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            @click="
              dialog_nuovo_op = true;
              caricaOperatoriDisponibili();
            "
            small
            v-bind="attrs"
            v-on="on"
            class="mr-5"
          >
            <v-icon color="primary">mdi-account-plus</v-icon>
          </v-btn>
        </template>
        <span>Aggiungi operatore</span>
      </v-tooltip>
      <v-spacer></v-spacer>
      <v-tooltip bottom v-if="filtri_visible === false">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            class="mr-5"
            @click="
              filtri_visible = true;
              item_filtro();
            "
            small
            v-bind="attrs"
            v-on="on"
            ><v-icon color="purple lighten-2">mdi-filter</v-icon></v-btn
          >
        </template>
        <span>Filtri</span>
      </v-tooltip>

      <v-tooltip
        bottom
        v-else-if="filtri_visible === true && prima_col == 'attivita'"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            class="mr-5"
            @click="
              filtri_visible = false;
              tipo = '';
              reparto = '';
              data_inizio_filt = data_inizio_gen;
              data_fine_filt = null;
              filtraMacchine();
              cambia_intervallo();
            "
            small
            v-bind="attrs"
            v-on="on"
          >
            <v-icon color="purple lighten-2">mdi-filter-off</v-icon>
          </v-btn>
        </template>
        <span>Ripristina</span>
      </v-tooltip>
      <v-tooltip
        bottom
        v-else-if="filtri_visible === true && prima_col == 'operatori'"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            class="mr-5"
            @click="
              filtri_visible = false;
              cognome = '';
              competenza = '';
              data_inizio_filt = data_inizio_gen;
              data_fine_filt = null;
              filtraMacchine();
              filtraData();
            "
            small
            v-bind="attrs"
            v-on="on"
          >
            <v-icon color="purple lighten-2">mdi-filter-off</v-icon>
          </v-btn>
        </template>
        <span>Ripristina</span>
      </v-tooltip>
      <v-spacer></v-spacer>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            class="mr-2"
            @click="dialog_conferma_elimina = true"
            small
            v-bind="attrs"
            v-on="on"
          >
            <v-icon color="error">mdi-undo</v-icon>
          </v-btn>
        </template>
        <span>Annulla modifiche</span>
      </v-tooltip>
    </v-toolbar>
    <v-row v-if="filtri_visible === true" align="center" justify="center">
      <v-col cols="2">
        <v-text-field
          v-model="data_inizio_filt"
          hide-details
          type="date"
          label="Data inizio"
        ></v-text-field>
      </v-col>
      <v-col cols="2">
        <v-text-field
          v-model="data_fine_filt"
          hide-details
          type="date"
          label="Data fine"
        >
        </v-text-field
      ></v-col>
      <v-col cols="1">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              v-bind="attrs"
              v-on="on"
              @click="filtraData()"
              color="primary"
              >mdi-filter</v-icon
            >
          </template>
          <span>Filtra date</span>
        </v-tooltip>
      </v-col>
      <v-col cols="1" class="pr-15 mr-5">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              v-bind="attrs"
              v-on="on"
              @click="
                data_inizio_filt = data_inizio_gen;
                data_fine_filt = null;
                filtraData();
              "
              color="primary"
              >mdi-filter-off</v-icon
            >
          </template>
          <span>Elimina filtro date</span>
        </v-tooltip>
      </v-col>
      <v-col cols="5" md="2" v-if="this.prima_col == 'attivita'">
        <v-autocomplete
          background-color="#ffffff"
          @change="filtraMacchine"
          hide-details
          :items="items"
          :item-text="(e) => e.des_attivita.tipo_macchina"
          item-value="des"
          label="Tipo macchina"
          style="display: inline-block; max-width: 200px"
          v-model="tipo"
        >
          <template v-slot:append>
            <v-icon
              class="ml-2"
              @click="
                tipo = '';
                filtraMacchine();
              "
              color="primary"
              >{{ tipo == "" ? "mdi-filter" : "mdi-filter-off" }}</v-icon
            >
          </template></v-autocomplete
        >
      </v-col>
      <v-col cols="5" md="2" v-if="this.prima_col == 'attivita'">
        <v-autocomplete
          background-color="#ffffff"
          @change="filtraMacchine"
          hide-details
          :items="items"
          :item-text="(e) => e.des_attivita.reparto_macchina"
          item-value="des"
          label="Reparto macchina"
          style="display: inline-block; max-width: 200px"
          v-model="reparto"
        >
          <template v-slot:append>
            <v-icon
              class="ml-2"
              @click="
                reparto = '';
                filtraMacchine();
              "
              color="primary"
              >{{ reparto == "" ? "mdi-filter" : "mdi-filter-off" }}</v-icon
            >
          </template>
        </v-autocomplete>
      </v-col>
      <v-col cols="5" md="2" v-if="this.prima_col == 'operatori'">
        <v-autocomplete
          background-color="#ffffff"
          @change="filtraMacchine"
          hide-details
          :items="items_op"
          :item-text="(e) => e.cognome"
          item-value="des"
          label="Cognome"
          style="display: inline-block; max-width: 200px"
          v-model="cognome"
        >
          <template v-slot:append>
            <v-icon
              class="ml-2"
              @click="
                cognome = '';
                filtraMacchine();
              "
              color="primary"
              >{{ cognome == "" ? "mdi-filter" : "mdi-filter-off" }}</v-icon
            >
          </template>
        </v-autocomplete>
      </v-col>

      <v-col cols="5" md="2" v-if="this.prima_col == 'operatori'">
        <v-autocomplete
          background-color="#ffffff"
          @change="filtraMacchine"
          hide-details
          :items="items_op"
          :item-text="(e) => e.competenza"
          item-value="des"
          label="Competenza"
          style="display: inline-block; max-width: 200px"
          v-model="competenza"
        >
          <template v-slot:append>
            <v-icon
              class="ml-2"
              @click="
                competenza = '';
                filtraMacchine();
              "
              color="primary"
              >{{ competenza == "" ? "mdi-filter" : "mdi-filter-off" }}</v-icon
            >
          </template>
        </v-autocomplete>
      </v-col>
    </v-row>
    <div>
      <Diagram
        :nome_key="nome_key"
        :prima_col="prima_col"
        :zoom_sched="zoom_sched"
        :colore_righe="colore_righe"
        :nome_op="nome_op"
        :fase="fase"
        :data_inizio_filt="data_inizio_filt"
        :data_fine_filt="data_fine_filt"
        style="margin-top: 0px"
        ref="diagram"
        :key="visualizza_macchine"
        @fine-build="dopoBuild"
      >
        <template v-slot:bottoni>
          <section v-if="diagram != null">
            <v-autocomplete
              background-color="#ffffff"
              class="centered-input"
              @change="cambia_intervallo"
              hide-details
              :items="tempo"
              item-value="tempo"
              label="Unità di tempo"
              style="display: inline-block"
              v-model="cambia_tempo"
            >
            </v-autocomplete>
          </section>
        </template>
      </Diagram>

      <!-- Dialog di scelta del WO da aggiungere -->
      <v-dialog v-model="dialog_wo" persistent>
        <ConsuntivoWO
          @inviati_wo="dialog_wo = false"
          @click_chiudi="chiudiDialogWO"
          :visible="dialog_wo"
          :dropDB="dropDB"
          :metodo_default="metodo_default"
        />
      </v-dialog>

      <!-- Snackbar -->
      <SnackbarQV ref="SnackbarQV" />
    </div>
    <!-- DIALOG CONFERMA SALVATAGGIO -->
    <v-dialog v-model="dialog_conferma_salva" width="unset">
      <v-card>
        <v-toolbar
          class="white--text"
          color="indigo"
          style="position: sticky; top: 0px; z-index: 1"
          dense
        >
          <v-toolbar-title>Salva</v-toolbar-title>
          <v-spacer></v-spacer>
          <!-- Bottone di salvataggio -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="
                  salva();
                  dialog_conferma_salva = false;
                "
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="success"> mdi-floppy </v-icon>
              </v-btn>
            </template>
            <span>Salva</span>
          </v-tooltip>
          <v-spacer></v-spacer>
          <!-- Bottone di chiusura -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="dialog_conferma_salva = false"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="error"> mdi-close </v-icon>
              </v-btn>
            </template>
            <span>Annulla</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text class="mt-5 mb-0 pb-5">
          <h2 class="mt-5">
            Clicca salva per rendere definitive le modifiche <br />
            apportate alla schedulazione.
          </h2>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- DIALOG CONFERMA ELIMINAZIONE -->
    <v-dialog v-model="dialog_conferma_elimina" width="unset">
      <v-card>
        <v-toolbar
          class="white--text"
          color="indigo"
          style="position: sticky; top: 0px; z-index: 1"
          dense
        >
          <v-toolbar-title>Annulla modifiche</v-toolbar-title>
          <v-spacer></v-spacer>
          <!-- Bottone di conferma -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="
                  dropDB();
                  dialog_conferma_elimina = false;
                "
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="success"> mdi-floppy </v-icon>
              </v-btn>
            </template>
            <span>Conferma</span>
          </v-tooltip>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="dialog_conferma_elimina = false"
                small
                v-bind="attrs"
                v-on="on"
                ><v-icon color="error">mdi-close</v-icon></v-btn
              >
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text class="mt-5 mb-0 pb-5">
          <h2 class="mt-5">
            Clicca salva per annullare le ultime modifiche effettuate <br />
            e tornare all'ultima schedulazione salvata.
          </h2>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- DIALOG IMPOSTAZIONI -->
    <v-dialog v-model="dialog_op" min-width="400px" max-width="1000px">
      <v-card>
        <v-toolbar
          class="white--text"
          color="indigo"
          style="position: sticky; top: 0px; z-index: 1"
          dense
        >
          <v-toolbar-title>Impostazioni</v-toolbar-title>
          <v-spacer></v-spacer>
          <!-- Bottone di salvataggio -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="verificaModifiche()"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="success"> mdi-floppy </v-icon>
              </v-btn>
            </template>
            <span>Salva</span>
          </v-tooltip>
          <v-spacer></v-spacer>
          <!-- Bottone di chiusura -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="chiudiDialogOptions"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="error"> mdi-close </v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text class="mt-5 mb-0 pb-0">
          <v-row align="center" justify="start">
            <v-col cols="3">
              <h3>Aspetto diagramma:</h3>
            </v-col>
            <v-col cols="3">
              <v-switch
                v-model="colore_righe"
                :false-value="0"
                :true-value="1"
                :label="'Colore delle righe alternato'"
              ></v-switch>
            </v-col>
            <v-col cols="3">
              <v-switch
                v-model="nome_op"
                :false-value="0"
                :true-value="1"
                :label="'Nome operatori'"
              ></v-switch>
            </v-col>
            <v-col cols="3">
              <v-autocomplete
                background-color="#ffffff"
                class="centered-input"
                @change="cambia_intervallo"
                hide-details
                :items="tempo"
                item-value="tempo"
                label="Unità di tempo"
                style="display: inline-block"
                v-model="cambia_tempo"
              >
              </v-autocomplete
            ></v-col>
          </v-row>
          <v-row align="center" justify="start">
            <v-col cols="3">
              <h3>Aspetto fase:</h3>
            </v-col>
            <v-col cols="2">
              <v-switch
                v-model="fase.sw_cod_articolo"
                :false-value="0"
                :true-value="1"
                :label="'Codice articolo'"
              ></v-switch>
            </v-col>
            <v-col cols="2">
              <v-switch
                v-model="fase.sw_des_articolo"
                :false-value="0"
                :true-value="1"
                :label="'Descrizione articolo'"
              ></v-switch>
            </v-col>
            <v-col cols="2">
              <v-switch
                v-model="fase.sw_cod_commessa"
                :false-value="0"
                :true-value="1"
                :label="'Codice commessa'"
              ></v-switch>
            </v-col>
            <v-col cols="2">
              <v-switch
                v-model="fase.sw_numero_pezzi"
                :false-value="0"
                :true-value="1"
                :label="'Fase'"
              ></v-switch>
            </v-col>
          </v-row>
          <v-row align="center" justify="start">
            <v-col cols="3">
              <h3>Metodo di schedulazione:</h3>
            </v-col>
            <v-col cols="6">
              <template>
                <v-container class="px-0" fluid>
                  <v-radio-group v-model="metodo_default" dense row>
                    <v-radio label="Backward" value="Backward"></v-radio>
                    <v-radio label="Forward" value="Forward"></v-radio>
                  </v-radio-group>
                </v-container>
              </template>
            </v-col>
          </v-row>
          <v-row align="center" justify="start">
            <v-col cols="3">
              <h3>Data iniziale:</h3>
            </v-col>
            <v-col cols="6">
              <template>
                <v-container class="px-0" fluid>
                  <v-radio-group v-model="data_inizio_gen" dense row>
                    <v-radio label="Oggi" :value="data_oggi"></v-radio>
                    <v-radio
                      label="Inizio prima attivita"
                      :value="data_inizio_task"
                    ></v-radio>
                  </v-radio-group>
                </v-container> </template></v-col></v-row
        ></v-card-text>
      </v-card>
    </v-dialog>
    <!-- DIALOG CONFERMA OPZIONI -->
    <v-dialog v-model="dialog_conferma_opzioni" width="unset">
      <v-card>
        <v-toolbar
          class="white--text"
          color="indigo"
          style="position: sticky; top: 0px; z-index: 1"
          dense
        >
          <v-toolbar-title>Conferma salvataggio</v-toolbar-title>
          <v-spacer></v-spacer>
          <!-- Bottone di salvataggio -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="salvaImpostazioni()"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="success"> mdi-content-save-move-outline </v-icon>
              </v-btn>
            </template>
            <span>Salva e continua</span>
          </v-tooltip>
          <v-spacer></v-spacer>
          <!-- Bottone di chiusura -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="dialog_conferma_opzioni = false"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="error"> mdi-close </v-icon>
              </v-btn>
            </template>
            <span>Annulla</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text class="mt-5 mb-0 pb-5">
          <h2 class="mt-5">
            Sono presenti delle modifiche non salvate nella schedulazione
            attuale. Per non perderle, chiudere il form 'Cambio numero
            operatore' e cliccare il tasto 'Salva' nella pagine iniziale di
            QuickPlan (sopra al diagramma). Se si desidera perdere le modifiche
            non salvate cliccare invece sul bottone 'Salva e continua'
            all'interno di questo form.
          </h2>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- DIALOG NUOVO OPERATORE -->
    <v-dialog v-model="dialog_nuovo_op" max-width="600px">
      <v-card>
        <v-toolbar
          class="white--text"
          color="indigo"
          style="position: sticky; top: 0px; z-index: 1"
          dense
        >
          <v-toolbar-title>Nuovo operatore</v-toolbar-title>
          <v-spacer></v-spacer>
          <!-- Bottone di salvataggio -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="
                  salvaNuovoOp();
                  dialog_nuovo_op = false;
                "
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="success"> mdi-floppy </v-icon>
              </v-btn>
            </template>
            <span>Salva</span>
          </v-tooltip>
          <v-spacer></v-spacer>
          <!-- Bottone di chiusura -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="dialog_nuovo_op = false"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="error"> mdi-close </v-icon>
              </v-btn>
            </template>
            <span>Annulla</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text class="mt-5 mb-0 pb-5">
          <v-autocomplete
            background-color="#ffffff"
            hide-details
            multiple
            :items="lista_op_disponibili"
            :item-text="(e) => e.cognome"
            label="Operatori disponibili"
            style="display: inline-block; max-width: 200px"
            v-model="operatore_scelto"
          ></v-autocomplete>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-card>
</template>
<script>
import ConsuntivoWO from "@/components/SCHEDULATORE/ConsuntivoWO.vue";
import Diagram from "@/components/SCHEDULATORE/Diagram.vue";
import alasql from "alasql";
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";

export default {
  name: "Schedulatore",
  components: { Diagram, ConsuntivoWO, SnackbarQV },
  props: {},
  data() {
    return {
      dialog_wo: false,
      dialog_op: false,
      nome_key: "id_attivita",
      prima_col: "attivita",
      data_inizio_gen: null,
      data_oggi: new Date(),
      data_inizio_filt: null,
      data_fine_filt: null,
      data_inizio_task: null,
      zoom_sched: 3,
      diagram: null,
      cambia_tempo: "Giorni",
      dialog_conferma_salva: false,
      dialog_conferma_elimina: false,
      dialog_nuovo_op: false,
      dialog_conferma_opzioni: false,
      operatore_scelto: new Array(),
      lista_op_disponibili: new Array(),
      key_macchine: 0,
      key_operatori: 0,
      visualizza_macchine: true,
      nome_op: 0,
      colore_righe: 0,
      tipo: "",
      reparto: "",
      metodo_default: "Forward",
      cognome: "",
      competenza: "",
      filtri_visible: false,
      attivita: new Array(),
      tasks: new Array(),
      operatori: new Array(),

      // Visualizzazione titolo task
      fase: {
        sw_cod_articolo: 0,
        sw_des_articolo: 0,
        sw_cod_commessa: 0,
        sw_numero_pezzi: 0,
      },

      // Array
      items: new Array(),
      items_visualizzati: [],
      items_op: new Array(),
      tempo: [
        "Mezz'ore",
        "Ore",
        "Turni",
        "Giorni",
        "Settimane",
        "Mesi",
        "Anni",
      ],
    };
  },
  computed: {},
  watch: {
    variabile: {
      immediate: true,
      handler() {},
    },
  },

  methods: {
    apriDialogWO() {
      console.log("entrato apri WO");
      this.dialog_wo = true;
    },

    chiudiDialogWO() {
      this.dialog_wo = false;
    },

    apriDialogOptions() {
      this.dialog_op = true;
    },

    chiudiDialogOptions() {
      this.dialog_op = false;
      /* if (this.zoom_sched != 1) {
        this.dataInizioSetting();
      } */
      this.filtraData();
    },

    dataInizioSetting() {
      if (this.data_inizio_gen != null) {
        //this.data_inizio_gen.setHours(0);
        this.data_inizio_gen.setMinutes(0);
        this.data_inizio_gen.setSeconds(0);
        this.data_inizio_filt = this.data_inizio_gen;
        console.log(this.data_inizio_filt);
      }
    },

    async caricaOperatoriDisponibili() {
      let operatori_id = new Array();
      let commesse_rif = new Array();
      await new Promise((resolve) => {
        alasql(
          `ATTACH INDEXEDDB DATABASE commessa_db; \
            SELECT * FROM commessa_db.attivita`,
          [],
          function (res) {
            for (let i = 0; i < res[1].length; i++) {
              commesse_rif[i] = res[1][i].id_riferimento;
            }
            resolve();
          }
        );
      });
      await new Promise((resolve) => {
        alasql(
          `ATTACH INDEXEDDB DATABASE commessa_db; \
            SELECT * FROM commessa_db.operatori`,
          [],
          function (res) {
            for (let i = 0; i < res[1].length; i++) {
              operatori_id[i] = res[1][i].id_personale;
            }
            resolve();
          }
        );
      });

      console.log("Operatori: ", JSON.stringify(operatori_id));
      console.log("Commesse: ", JSON.stringify(commesse_rif));

      // Da inviare al BE operatori_id e commesse_rif per chiedere lista di operatori con competenze ma non ancora con task
      // Lista finta provvisoria getoperatori

      var request = {
        controller: "Schedulatore",
        method: "POST",
        richiesta: {
          action: "getoperatori",
          token: localStorage.getItem("user_token"),
          operatori: operatori_id.join(","),
          commesse: commesse_rif.join(","),
        },
      };

      return this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status == 200) {
            this.caricamento_dati = false;
            this.lista_op_disponibili = res.data;
          }
          return true;
        })
        .catch((err) => {
          console.log("ERRORE");
          console.log(err);
          return false;
        });

      /* this.lista_op_disponibili = [
        {
          cognome: "Rossi",
          competenza: "Collaudo",
          competenze: [
            { id: 126, descrizione: "Collaudo" },
            { id: 122, descrizione: "Set-up" },
          ],
          id: 0,
          id_competenza: 126,
          id_personale: 18,
          incarichi: 0,
          nome: "Pippo",
        },
        {
          cognome: "Verdi",
          competenza: "Set-up",
          competenze: [
            { id: 126, descrizione: "Collaudo" },
            { id: 122, descrizione: "Set-up" },
          ],
          id: 0,
          id_competenza: 126,
          id_personale: 7,
          incarichi: 0,
          nome: "Paperino",
        },
      ]; */
    },

    dropDB() {
      let that = this;
      if (this.$refs.diagram.CALENDAR.db_connection != null) {
        this.$refs.diagram.CALENDAR.db_connection.close();
        this.$refs.diagram.CALENDAR.db_connection = null;
      }
      console.log("entrato drop db", this.$refs.diagram.CALENDAR);
      try {
        var DBDeleteRequest = window.indexedDB.deleteDatabase("commessa_db");
        DBDeleteRequest.onerror = function () {
          console.log("Error deleting database.");
        };

        DBDeleteRequest.onsuccess = function () {
          console.log("Database deleted successfully");
          that.$refs.diagram.getJsonDalServer();
          window.location.reload();
        };
      } catch (error) {
        console.log("errore ", error);
      }

      window.location.reload();
    },

    async dataInizioTask() {
      let date_list_inizio = new Array();
      await new Promise((resolve) => {
        alasql(
          `ATTACH INDEXEDDB DATABASE commessa_db; \
            SELECT * FROM commessa_db.attivita ORDER BY dataInizio`,
          [],
          function (res) {
            for (let i = 0; i < res[1].length; i++) {
              let dataInizio = new Date();
              dataInizio = res[1][i].dataInizio;
              date_list_inizio.push(dataInizio);
            }
            resolve();
          }
        );
      });

      this.data_inizio_task = new Date(date_list_inizio[0]);
      console.log("------ " + this.data_inizio_task);
    },

    async item_filtro() {
      let macchine = new Array();
      await new Promise((resolve) => {
        alasql(
          `ATTACH INDEXEDDB DATABASE commessa_db; \
            SELECT * FROM commessa_db.attivita`,
          [],
          function (res) {
            macchine = res[1];
            resolve();
          }
        );
      });

      for (let j = 0; j < macchine.length; j++) {
        this.items[j] = macchine[j];
        if (this.items[j].des_attivita.tipo_macchina == "") {
          this.items[j].des_attivita.tipo_macchina = "Non presente";
        }
        if (this.items[j].des_attivita.reparto_macchina == "") {
          this.items[j].des_attivita.reparto_macchina = "Non presente";
        }
        //console.log(this.items[j].des_attivita.macchina);
      }
      //console.log(this.items);

      let operatori = new Array();
      await new Promise((resolve) => {
        alasql(
          `ATTACH INDEXEDDB DATABASE commessa_db; \
            SELECT * FROM commessa_db.operatori`,
          [],
          function (res) {
            operatori = res[1];
            resolve();
          }
        );
      });

      for (let j = 0; j < operatori.length; j++) {
        this.items_op[j] = operatori[j];

        // Da modificare nel caso non ci siano valori nella competenza

        /* if (this.items[j].des_attivita.reparto_macchina == "") {
            this.items[j].des_attivita.reparto_macchina = "Non presente";
          }
          console.log(this.items[j].des_attivita.macchina); */

        //console.log(this.items_op);
      }
    },

    async dopoBuild() {
      await this.item_filtro();
      await this.dataInizioTask();
      await this.getImpostazioni();
      await this.filtraData();
      this.filtraMacchine();

      console.log("DATA INIZIO FILT DOPO BUILD: " + this.data_inizio_filt);
    },

    switchVista() {
      this.visualizza_macchine = !this.visualizza_macchine;
      for (let i = 0; i < this.tempo.length; i++) {
        if (this.tempo[i] == this.cambia_tempo) {
          this.zoom_sched = i;
        }
      }

      if (this.visualizza_macchine) {
        this.nome_key = "id_attivita";
        this.prima_col = "attivita";
        // console.log("tipo switch ", this.tipo);
      } else {
        this.nome_key = "id_personale";
        this.prima_col = "operatori";
      }

      if (this.prima_col == "attivita") {
        if (this.tipo != "" || this.reparto != "") {
          this.filtri_visible = true;
        }
      } else if (this.prima_col == "operatori") {
        if (this.cognome != "" || this.competenza != "") {
          this.filtri_visible = true;
        }
      }
    },

    async filtraData() {
      // console.log("Filtra data");
      if (this.cambia_tempo != "") {
        for (let i = 0; i < this.tempo.length; i++) {
          if (this.tempo[i] == this.cambia_tempo) {
            this.zoom_sched = i;
          }
        }
      }
      console.log(
        this.zoom_sched +
          "-" +
          this.prima_col +
          "-" +
          this.data_inizio_filt +
          "-" +
          this.data_fine_filt
      );

      console.log("DATA INIZIO FILTRO: " + this.data_inizio_filt);

      this.$refs.diagram.CALENDAR.setZoom(this.zoom_sched);
      await this.$refs.diagram.CALENDAR.build(
        this[this.prima_col],
        this.tasks,
        this.nome_key,
        this.prima_col,
        this.data_inizio_filt,
        this.data_fine_filt
      );
      this.filtraMacchine();
    },

    filtraMacchine() {
      //console.log(this.prima_col);

      let row = document.getElementsByTagName("tr");
      for (let i = 0; i < row.length; i++) {
        row[i].style.removeProperty("display");
      }

      let items_id = [];
      let items_temp = [];

      if (this.prima_col == "operatori") {
        this.items_op.forEach((elem) => {
          items_temp.push(elem);
          items_id.push(elem[this.nome_key]);
        });
      }

      if (this.prima_col == "attivita") {
        this.items.forEach((elem) => {
          items_temp.push(elem);
          items_id.push(elem[this.nome_key]);
        });
      }

      //console.log(items_temp);

      if (this.prima_col == "attivita") {
        // Filtro il tipo
        if (this.tipo != "") {
          let res = [];
          items_id = [];
          items_temp.forEach((elem) => {
            if (elem.des_attivita.tipo_macchina == this.tipo) {
              res.push(elem);
              items_id.push(elem.id_attivita);
            }
          });

          items_temp = res;
        }

        // Filtro il reparto
        if (this.reparto != "") {
          let res = [];
          items_id = [];
          items_temp.forEach((elem) => {
            if (elem.des_attivita.reparto_macchina == this.reparto) {
              res.push(elem);
              items_id.push(elem.id_attivita);
            }
          });

          items_temp = res;
        }

        this.items_visualizzati = [];
        this.items_visualizzati = items_id;
        //console.log(this.items_visualizzati);

        let attivita = document.getElementsByTagName("tr");

        if (this.items_visualizzati.length == 0) {
          for (let j = 0; j < attivita.length; j++) {
            if (attivita[j].getAttribute("elemento") == "attivita_row") {
              attivita[j].style.display = "none";
            }
          }
        }
        //this.username.split("/")[1];
        for (let i = 0; i < this.items_visualizzati.length; i++) {
          for (let j = 0; j < attivita.length; j++) {
            if (attivita[j].getAttribute("elemento") == "attivita_row") {
              if (
                attivita[j].id.split("-")[0] !=
                "attivita" + this.items_visualizzati[i]
              ) {
                attivita[j].style.display = "none";
              }
            }
          }
        }

        for (let i = 0; i < this.items_visualizzati.length; i++) {
          for (let j = 0; j < attivita.length; j++) {
            if (
              attivita[j].id.split("-")[0] ==
              "attivita" + this.items_visualizzati[i]
            ) {
              attivita[j].style.removeProperty("display");
            }
          }
        }
      } else {
        // Filtro il cognome
        if (this.cognome != "") {
          let res = [];
          items_id = [];
          items_temp.forEach((elem) => {
            if (elem.cognome == this.cognome) {
              res.push(elem);
              items_id.push(elem.id_personale);
            }
          });

          items_temp = res;
        }

        // Filtro la competenza
        if (this.competenza != "") {
          let res = [];
          items_id = [];

          items_temp.forEach((elem) => {
            if (elem.competenze != null) {
              for (let i = 0; i < elem.competenze.length; i++) {
                if (elem.competenze[i].descrizione == this.competenza) {
                  res.push(elem);
                  items_id.push(elem.id_personale);
                }
              }
            }
          });

          items_temp = res;
        }

        this.items_visualizzati = [];
        this.items_visualizzati = items_id;
        //console.log(this.items_visualizzati);

        let operatori = document.getElementsByTagName("tr");

        if (this.items_visualizzati.length == 0) {
          for (let j = 0; j < operatori.length; j++) {
            if (operatori[j].getAttribute("elemento") == "attivita_row") {
              operatori[j].style.display = "none";
            }
          }
        }
        //this.username.split("/")[1];
        for (let i = 0; i < this.items_visualizzati.length; i++) {
          for (let j = 0; j < operatori.length; j++) {
            if (operatori[j].getAttribute("elemento") == "attivita_row") {
              if (
                operatori[j].id.split("-")[0] !=
                "operatori" + this.items_visualizzati[i]
              ) {
                operatori[j].style.display = "none";
              }
            }
          }
        }

        for (let i = 0; i < this.items_visualizzati.length; i++) {
          for (let j = 0; j < operatori.length; j++) {
            if (
              operatori[j].id.split("-")[0] ==
              "operatori" + this.items_visualizzati[i]
            ) {
              operatori[j].style.removeProperty("display");
            }
          }
        }
      }
    },

    async salva() {
      let task_modificati = new Array();

      await new Promise((resolve) => {
        alasql(
          `ATTACH INDEXEDDB DATABASE commessa_db; \
            SELECT * FROM commessa_db.task WHERE modificato = 1`,
          [],
          function (res) {
            task_modificati = res[1];
            //console.log("risultato query" + res);

            resolve();
          }
        );
      });

      console.log("Task modificati query");
      console.log(task_modificati);
      const arr_tmp = task_modificati;
      const request = {
        controller: "Schedulatore",
        method: "POST",
        richiesta: {
          action: "saveTask",
          token: localStorage.user_token,
          task: arr_tmp,
        },
      };

      // Inserisco un overlay di caricamento.
      this.caricamento_dati = true;

      this.$store
        .dispatch("api", request)
        .then((res) => {
          // Tolgo l'overlay di caricamento.
          this.caricamento_dati = false;

          if (res.status === 200) {
            this.$emit("inviati_wo");

            // Stampo una snackbar di conferma.
            this.$refs.SnackbarQV.print("success", "Salvataggio effettuato.");
          }
        })
        .catch((err) => {
          // Tolgo l'overlay di caricamento.
          this.caricamento_dati = false;

          // Stampo una snackbar di avviso.
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile caricare i dati."
          );

          // Stampo il log dell'errore in console.
          console.error(err);
        });
      await new Promise((resolve) => {
        alasql(
          `ATTACH INDEXEDDB DATABASE commessa_db; \
            UPDATE commessa_db.task SET modificato = null`,
          [],
          function () {
            resolve();
          }
        );
      });
    },

    getImpostazioni() {
      var request = {
        controller: "Schedulatore",
        method: "POST",
        richiesta: {
          action: "getconfig",
          token: localStorage.getItem("user_token"),
        },
      };

      return this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status == 200) {
            this.colore_righe = res.data.colore_righe_alternato;
            this.nome_op = res.data.nome_operatori;
            this.metodo_default = res.data.tipo_schedulazione;
            this.cambia_tempo = res.data.unita_tempo;
            let vista_iniziale = res.data.vista_iniziale;
            let fase_arrivo = parseInt(res.data.aspetto_fase).toString(2);
            console.log(fase_arrivo);

            if (fase_arrivo == 0) {
              fase_arrivo = "0000";
            }
            this.fase.sw_cod_articolo = parseInt(fase_arrivo[0]);
            this.fase.sw_des_articolo = parseInt(fase_arrivo[1]);
            this.fase.sw_cod_commessa = parseInt(fase_arrivo[2]);
            this.fase.sw_numero_pezzi = parseInt(fase_arrivo[3]);
            console.log(this.fase.sw_numero_pezzi);

            if (vista_iniziale == "oggi") {
              this.data_oggi.setHours(0);
              this.data_oggi.setMinutes(0);
              this.data_oggi.setSeconds(0);
              this.data_inizio_filt = this.data_oggi;
              this.data_inizio_gen = this.data_oggi;
            } else if (vista_iniziale == "prima_attivita") {
              this.data_inizio_filt = this.data_inizio_task;
              this.data_inizio_gen = this.data_inizio_task;
              console.log(this.data_inizio_gen);
            }

            if (this.metodo_default == "forward") {
              this.metodo_default = "Forward";
            }
          }

          return true;
        })
        .catch((err) => {
          console.log("ERRORE");
          console.log(err);
          return false;
        });
    },

    salvaImpostazioni() {
      //let number = 12;
      // Da intero a binario
      // let binario = number.toString(2);

      // Da binario a intero
      //var numero_2 = parseInt(binario, 2);

      let fase_num_str =
        this.fase.sw_cod_articolo.toString() +
        this.fase.sw_des_articolo.toString() +
        this.fase.sw_cod_commessa.toString() +
        this.fase.sw_numero_pezzi.toString();

      console.log(fase_num_str);
      let vista_iniziale = "prima_attivita";

      this.dataInizioSetting();
      this.data_oggi.setHours(0);
      this.data_oggi.setMinutes(0);
      this.data_oggi.setSeconds(0);

      console.log(this.data_inizio_filt + "-" + this.data_oggi);

      if (this.data_inizio_filt == this.data_oggi) {
        vista_iniziale = "oggi";
      }

      var request = {
        controller: "Schedulatore",
        method: "POST",
        richiesta: {
          action: "saveconfig",
          token: localStorage.getItem("user_token"),
          config: {
            id_config: 1,
            colore_righe_alternato: this.colore_righe,
            nome_operatori: this.nome_op,
            tipo_schedulazione: this.metodo_default,
            unita_tempo: this.cambia_tempo,
            vista_iniziale: vista_iniziale,
            aspetto_fase: fase_num_str,
          },
        },
      };

      return this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status == 200) {
            this.$refs.SnackbarQV.print("success", "Salvataggio effettuato.");
            this.dialog_conferma_opzioni = false;
            this.filtraData();
            this.dialog_op = false;
          }

          return true;
        })
        .catch((err) => {
          console.log("ERRORE");
          console.log(err);
          return false;
        });
    },

    async verificaModifiche() {
      let modificati = new Array();
      await new Promise((resolve) => {
        alasql(
          `ATTACH INDEXEDDB DATABASE commessa_db; \
          SELECT * FROM commessa_db.task WHERE modificato = 1`,
          [],
          function (res) {
            for (let i = 0; i < res[1].length; i++) {
              modificati[i] = res[1][i];
            }
            resolve();
          }
        );
      });

      if (modificati.length != 0) {
        this.dialog_conferma_opzioni = true;
      } else {
        this.salvaImpostazioni();
      }
    },

    async salvaNuovoOp() {
      let operatore_nuovo = new Array();

      for (let k = 0; k < this.operatore_scelto.length; k++) {
        for (let i = 0; i < this.lista_op_disponibili.length; i++) {
          if (
            this.lista_op_disponibili[i].cognome == this.operatore_scelto[k]
          ) {
            operatore_nuovo.push(this.lista_op_disponibili[i]);
          }
        }
      }
      console.log(this.operatore_scelto);

      let db = null;
      var request = indexedDB.open("commessa_db", 5);
      request.onerror = function (event) {
        console.log("errore apertura DB" + event);
      };

      request.onsuccess = function (res) {
        db = res.target.result;
        console.log("database aperto");
        console.log(operatore_nuovo);
        var opObjectStore = db
          .transaction("operatori", "readwrite")
          .objectStore("operatori");

        operatore_nuovo.forEach((op) => {
          opObjectStore.add(op);
        });
      };

      await this.$refs.diagram.CALENDAR.build(
        this[this.prima_col],
        this.tasks,
        this.nome_key,
        this.prima_col,
        this.data_inizio_filt,
        this.data_fine_filt
      );

      this.operatore_scelto = null;
    },

    async cambia_intervallo() {
      for (let i = 0; i < this.tempo.length; i++) {
        if (this.tempo[i] == this.cambia_tempo) {
          this.zoom_sched = i;
          await this.diagram.switchView(
            i,
            this.prima_col,
            this.nome_key,
            this.data_inizio_filt,
            this.data_fine_filt
          );
        }
      }

      if (this.cambia_tempo == "") {
        await this.diagram.switchView(
          this.zoom_sched,
          this.prima_col,
          this.nome_key,
          this.data_inizio_filt,
          this.data_fine_filt
        );
      }

      console.log("tipo ", this.tipo);
      console.log("reparto ", this.reparto);
      this.filtraMacchine();
    },
  },
  created() {},
  async mounted() {
    this.filtraMacchine();
    this.diagram = this.$refs.diagram;
    console.log(this.data_inizio_task);
    console.log(this.data_inizio_filt);
  },
};
</script>
<style scoped>
</style>